function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { Bounds, intersect } from 'vega-scenegraph';
import { array } from 'vega-util';
export default function (b, opt, group) {
  if (!b) return [];

  var _b = _slicedToArray(b, 2),
      u = _b[0],
      v = _b[1],
      box = new Bounds().set(u[0], u[1], v[0], v[1]),
      scene = group || this.context.dataflow.scenegraph().root;

  return intersect(scene, box, filter(opt));
}

function filter(opt) {
  var p = null;

  if (opt) {
    var types = array(opt.marktype),
        names = array(opt.markname);

    p = function p(_) {
      return (!types.length || types.some(function (t) {
        return _.marktype === t;
      })) && (!names.length || names.some(function (s) {
        return _.name === s;
      }));
    };
  }

  return p;
}